import { render, staticRenderFns } from "./BotAvatar.vue?vue&type=template&id=3c3a0123"
import script from "./BotAvatar.vue?vue&type=script&lang=ts"
export * from "./BotAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports